import { NavigationService } from './navigation.service';
import { ReferralService } from './referral.service';
import { SideNavService } from './side-nav.service';

export const services = [NavigationService, SideNavService, ReferralService];

export * from './navigation.service';
export * from './referral.service';
export * from './side-nav.service';
